import TableSearchHeader from "../../../components/CustomTable/TableSearchHeader";
import Loading from "../../../components/atoms/Loading";
import Table2 from "../../../components/main/Table/Table2";
import {HeaderSystem} from "../../../data/TablesHeader";
import ListsOperations from "../../../tools/consts";
import Pagination from "../../../components/main/Pagination";
import DeleteModal from "../../../components/atoms/DeleteModal";
import AddWarrantyModal from "../../../components/systemPage/AddWarrantyModal";
import {Toaster} from "react-hot-toast";
import React from "react";
import {useConfigContext} from "../ConfigContext";

const WarrantyListSection = () => {
    const {
        listState,
        closeModal,
        modalState,
        openModal,
        changePage,
        onSearchBtnClick,
        deleteCallback
    } = useConfigContext();

    return (
        <div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
            dir="rtl">
            <TableSearchHeader
                title={"مدیریت شماره گارانتی"}
                number={listState.countAll}
                placeholder={"جست و جو: شماره گارانتی، شماره سریال دستگاه"}
                countUnit={""}
                onSearchBtnClick={onSearchBtnClick}
                hasBtn={true}
                buttnText={"افزودن شماره جدید"}
                onClick={() => {
                    openModal("add")

                }}
                exportFile={false}
                path={""}
            />


            {listState.loading ? (
                <Loading height={"h-37v"}/>
            ) : (
                <>
                    <Table2
                        headers={HeaderSystem}
                        tableData={listState.list}
                        heightEmptyState={'h-37v'}
                        emptyText={"گارانتی یافت نشد"}
                        pageNumber={listState.pageNumber}
                        limit={listState.pageLimit}
                        hasOperation={true}
                        operations={ListsOperations.getSystemList((value) => {
                            console.log("VALUEEE :", value)
                            openModal("delete", value)
                        })}
                    />
                    <Pagination
                        changePage={changePage}
                        countAll={listState.countAll}
                        currentPage={listState.pageNumber}
                    />
                </>
            )}

            <DeleteModal
                text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.garantinumber}” مطمئن هستید؟`}
                showDeleteModal={modalState.isOpen && modalState.mode === "delete"}
                closeDeleteModal={closeModal}
                RemoveItem={deleteCallback}
                title="اخطار حذف شماره گارانتی"
            />
            <AddWarrantyModal/>
            <Toaster/>

        </div>
    )

}
export default WarrantyListSection;